import { CountryItemI } from '@/modules/register/types/api/RegisterUser'

export default class CountryItem {
  callingCode: number
  name: string
  key: string
  constructor(item: CountryItemI) {
    this.callingCode = item.callingCode
    this.name = item.name
    this.key = item.key
  }
}
